module.exports = __webpack_public_path__ + "img/九份.6b01ff9c.png";